import { Component, ComponentChildren } from 'preact';
import { logger } from '@accedo/logger';
import { ErrorScreenContext } from './ErrorScreenContext';
import { ErrorBoundaryState, ErrorScreenContextValue } from './types';

export class ErrorBoundary extends Component<{}, ErrorBoundaryState> {
  // eslint-disable-next-line react/sort-comp
  static contextType = ErrorScreenContext;

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    logger.error('[ErrorBoundary] Error: ', error);
    return { error, hasError: true };
  }

  // This method can be used to log error to external systems
  // componentDidCatch(error: Error): void {
  // }

  render(): Element | ComponentChildren {
    const { showError, hasError } = this.context as ErrorScreenContextValue;

    if (this.state.hasError && !hasError) {
      showError('GENERIC_ERROR');

      return <></>;
    }

    return this.props.children;
  }
}
